module.exports = __webpack_public_path__ + "media/corporate-image/gear-naname-5ca755e949a86442cc52e0f160bcb5b7.png";